module.exports = __webpack_public_path__ + "img/dok_logo.c603904a.png";